/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Tabs, Alert } from 'antd';
import { useTranslation } from "react-i18next";

import { repeatObjects, isGroupInput, groupSubsections, showHideInput } from './helper';

import Group from './components/group';
import Input from './components/input';
import RepeatableGroup from './components/repeatableGroup';
import RepeatableModals from './components/repeatableModals';
import { GetIcon } from 'datastake-daf/dist/components';
import { getInputLabel } from '../Edit/helper';
import CustomWrapper from './components/customWrapper';
import TypesOfRisksCovered from './components/warningComponents/typesOfRisksCovered';
import AdditionalCRAFTRequirements from './components/warningComponents/additionalCRAFTRequirements';
import { layoutTypes } from '../EditCADD/helper';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Content = ({
  style = {},
  form = {},
  data = {},
  groupConfig = {},
  linkingData = {},
  linkingForms = {},
  ajaxOptions = [],
  group,
  canEdit = false,
  layout = layoutTypes.DEFAULT,
  viewConfig = {},
  namespace,
}) => {
  const { i18n: { language }, t } = useTranslation();
  const [comment, setComment] = useState(null);

  useEffect(() => {
    if (data) {
      const com = data[`${group}Comment`];
      if (com) {
        setComment(com);
      } else if (comment) {
        setComment(null);
      }
    }
  }, [data, group]);

  const groupSingle = (grps) => {
    const form = Object.keys(grps).reduce((f, gKey) => {
      if (
        grps[gKey].inputType !== 'modal' &&
        !isGroupInput(grps[gKey], false) &&
        !isGroupInput(grps[gKey], true) &&
        grps[gKey].display !== 'group' &&
        !grps[gKey].viewGroup &&
        !grps[gKey].component) {
        if (grps[gKey].group && !f[grps[gKey].group]) {
          f[grps[gKey].group] = {};
          Object.assign(f[grps[gKey].group], { [gKey]: grps[gKey] });
        } else if (grps[gKey].group && f[grps[gKey].group]) {
          Object.assign(f[grps[gKey].group], { [gKey]: grps[gKey] });
        }
      }
      return f;
    }, {});
    return form;
  }

  const getDisplayGroupConfig = (groups, key) => {
    return Object.keys(groups).reduce((items, gKey) => {
      if (groups[gKey].viewGroup === key) {
        const { viewGroup, ...gCfg } = groups[gKey];
        items[gKey] = gCfg;
      }
      return items;
    }, {});
  }

  const getComponent = (component, key, config) => {
    switch (component) {
      case 'repeatableModals':
        return <RepeatableModals
          key={key}
          name={key}
          data={data}
          config={config}
          linkingData={linkingData}
          linkingForms={linkingForms}
          ajaxOptions={ajaxOptions}
        />;
      default:
        return <p>Component</p>;
    }
  }

  const isDisplayGroup = (input) => input.display && input.display === 'group';
  const isSingleModal = (input) => input.inputType && input.inputType === 'modal';
  const hasComponent = (input) => input.component && typeof input.component === 'string';

  const typeRender = (groups, singleGroupsKeys, addedContent) => {
    return repeatObjects(groups, (key, i) => {
      // normal group
      return hasComponent(groups[key]) ? getComponent(groups[key].component, key, groups[key]) : isGroupInput(groups[key], false)
        ? (
          <React.Fragment key={`${key}${i}`}>
            {groups[key].viewShowIf ? showHideInput(groups[key], data) ?
              <Group
                key={key}
                name={key}
                linkingData={linkingData}
                config={groups[key]}
                data={data}
                allData={data}
                linkingForms={linkingForms}
                cols={2}
                ajaxOptions={ajaxOptions}
              />
              : null
              : <Group
                key={key}
                name={key}
                linkingData={linkingData}
                config={groups[key]}
                data={data}
                allData={data}
                linkingForms={linkingForms}
                cols={2}
                ajaxOptions={ajaxOptions}
              />
            }
          </React.Fragment>
        )
        // repeatable group
        : isGroupInput(groups[key], true)
          ? (groups[key].viewShowIf ? (showHideInput(groups[key], data) ? <RepeatableGroup
            key={key}
            name={key}
            config={groups[key]}
            data={data}
            allData={data}
            linkingData={linkingData}
            linkingForms={linkingForms}
            viewConfig={viewConfig}
            ajaxOptions={ajaxOptions}>
          </RepeatableGroup> : null) : <RepeatableGroup
            key={key}
            name={key}
            config={groups[key]}
            viewConfig={viewConfig}
            data={data}
            allData={data}
            linkingData={linkingData}
            linkingForms={linkingForms}
            ajaxOptions={ajaxOptions}>
          </RepeatableGroup>)
          // single inputs grouped
          : singleGroupsKeys.includes(key) ? (() => {
            if (!addedContent.includes(key)) {
              const currentGroup = Object.keys(groupSingle(groups))
                .find(k => Object.keys(groupSingle(groups)[k]).includes(key));
              addedContent.push(...Object.keys(groupSingle(groups)[currentGroup]));
              const config = groupSingle(groups)[currentGroup];
              return <div className="group" key={`${currentGroup}-${Date.now()}`}>
                {groupConfig[currentGroup] ? <div className="title">
                  <h1>{groupConfig[currentGroup][language]}</h1>
                </div> : null}
                <Input
                  key={key}
                  name={config.dataId || key}
                  config={config}
                  data={data}
                  allData={data}
                  linkingData={linkingData}
                  linkingForms={linkingForms}
                  ajaxOptions={ajaxOptions}
                  cols={2}
                />
              </div>
            }
          })()
            // display group
            : isDisplayGroup(groups[key])
              ? (
                <div className="group display" key={key}>
                  <div className="title">
                    <h1>{groups[key].label}</h1>
                  </div>
                  {typeRender(getDisplayGroupConfig(groups, key), singleGroupsKeys, addedContent)}
                </div>
              )
              // single modal
              : isSingleModal(groups[key])
                ? (
                  <div className="group" key={key}>
                    <div className="title">
                      <h1>{groups[key].outputLabel || getInputLabel(groups[key], data)}</h1>
                    </div>
                    <Input
                      key={key}
                      parent={key}
                      name={groups[key].dataId || key}
                      config={groups[key]}
                      data={data}
                      allData={data}
                      linkingData={linkingData}
                      linkingForms={linkingForms}
                      ajaxOptions={ajaxOptions}
                      cols={2}
                    />
                  </div>
                )
                : null;
    });
  }

  useEffect(() => {
    setTimeout(() => {
      const groups = Array.from(document.getElementsByClassName('group'));
      groups.forEach(group => {
        const inputs = Array.from(group.querySelectorAll('.input'));
        // remove groups without inputs
        if (!inputs.length) {
          group.remove();
        }
      });
    }, 200)
  }, [form, data])

  const hasSubSections = false;

  const renderContent = (f, showTitle = true) => {
    if (f) {
      const alertType = ['error', 'warning', 'info', 'success'];
      if (f.alertConf && f.alertConf.type === 'warning') {
        if (f.warningComponent) {
          switch (f.warningComponent) {
            case "typesOfRisksCovered":
              return (
                <TypesOfRisksCovered
                  t={t}
                  canEdit={canEdit}
                  body={form ? (form.outputLabel || getInputLabel(form, data)) : ''}
                />
              );
            case "additionalCRAFTRequirements":
              return (
                <AdditionalCRAFTRequirements
                  t={t}
                  canEdit={canEdit}
                  body={form ? (form.outputLabel || getInputLabel(form, data)) : ''}
                />
              );
            default:
          }
        }

        if (f.alertConf.text) {
          return <Alert message={f.alertConf.text} type={f.alertConf.type} showIcon />
        }
      }
      let { label, icon, position, ...groups } = f;
      groups = Object.keys(groups).reduce((items, key) => {
        if (!groups[key].excludeFromView) {
          items[key] = groups[key];
        }
        return items;
      }, {});
      const addedContent = [];
      const singleGroupsKeys = [].concat(...Object.keys(groupSingle(groups))
        .map(key => Object.keys(groupSingle(groups)[key])));
      return <>
        {(layout === layoutTypes.DEFAULT) && (
          <CustomWrapper
            t={t}
            type="header"
            body={form ? (form.outputLabel || getInputLabel(form, data)) : ''}
            icon={form.icon}
            formDescription={form.formDescription}
          />
        )}
        <div
          className={formatClassname(["wrapper", `${namespace}_${group}`])}
          key={Date.now()}
        >
          {(layout === layoutTypes.DOCUMENTS_LAYOUT || layout === layoutTypes.PROJECT) && (
            <div className="view-header">
              <h1>{label}</h1>
            </div>
          )}
          {showTitle ? <h1 className="title">{f ? getInputLabel(f, data) : ''}</h1> : null}
          {typeRender(groups, singleGroupsKeys, addedContent)}
        </div>
      </>
    }
  }

  let groupSections = [];
  if (hasSubSections) {
    groupSections = groupSubsections(form);
  }

  return (
    <div
      className={formatClassname([
        'content',
        (layout === layoutTypes.DOCUMENTS_LAYOUT || layout === layoutTypes.PROJECT) && 'documents-layout',
        layout === layoutTypes.PROJECT && 'project-layout',
      ])}
      style={style}
    >
      <div className="content-card">
        {!hasSubSections ? renderContent(form, false) : (
          <React.Fragment>
            <Tabs className="section-tabs">
              {repeatObjects(groupSections, (key) => {
                const section = groupSections[key];
                return <Tabs.TabPane style={{
                  maxHeight: 'calc(100vh - 100px)',
                  overflowY: 'auto'
                }}
                  tab={
                    <span>
                      {section.icon ?
                        <GetIcon icon={section.icon} /> : null} {getInputLabel(section, data)}
                    </span>
                  }
                  key={key}>
                  {renderContent(groupSections[key], false)}
                </Tabs.TabPane>
              })}
            </Tabs>
          </React.Fragment>
        )}
        {(form?.alertConf?.type !== 'warning' && ['sp', 'im', 'sci', 'bpe', 'gm'].includes(namespace)) ? (
          <CustomWrapper
            t={t}
            type="commentOutput"
            body={comment}
          />
        ) : null}
      </div>
    </div>
  );
}

export default Content;
